import Navbar from "../components/Navbar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import IsiTerms from "../components/IsiTerms";

export default function TOSPage() {
  return (
    <div>
      <Navbar />
      <Header />
      <IsiTerms />
      <Footer />
    </div>
  );
}